import {AxiosResponse} from 'axios'
import {PersonTagRequest, PhotoPersonTag} from './types'
import {HttpInstance} from '../createHttpInstance'

export interface GetPhotoTag<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const getPhotoTag: GetPhotoTag<PersonTagRequest, PhotoPersonTag> = (
  http,
  params,
) => {
  const {ClientID, PersonID, PhotoID} = params

  const path = '/v1/photos/{photoid}/person-tags/{personid}'
    .replace('{personid}', PersonID.toString())
    .replace('{photoid}', PhotoID.toString())

  return http.request<PhotoPersonTag>({
    method: 'GET',
    url: `${path}?clientid=${ClientID}`,
  })
}
